export default {
  contentList: [],
  totalItems: 0,
  isLoading: false
};
